import React from 'react';
import loadable from '@loadable/component';

const RentalTypesFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "RentalTypesFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/RentalTypesFilter/component'
    ),
);

class LoadableRentalTypesFilter extends React.Component {
  render() {
    return <RentalTypesFilter {...this.props} />;
  }
}

export default LoadableRentalTypesFilter;
